
                import "css-modules://src_components_pagenavigation"
                export default {"Main":"_4db49f","Inner":"_26a0c2","Arrow":"_ade37a","Prev":"_7ad393","Next":"_219bb9","Label":"_b5ae7b"}
            